import messages from '@/common/data/messages.data';
import userApi from '@/common/api/user.api';
import i18n, { getBrowserLanguage } from '@/plugins/i18n';

const getLanguageByCode = () => {
	const user = userApi.getCurrentUser();
	if (user && user.language) {
		return user.language;
	}
	return getBrowserLanguage(i18n.fallbackLocale[navigator.language] ?? 'en');
};

const getTooltip = (code) => {
	let [resource, action] = code.split('.');

	let config = messages.tooltips[resource][action];

	const language = getLanguageByCode();

	return config[language];
};

const getMessage = (error) => {
	let result;
	if (typeof error === 'string') {
		// try {
		// error = JSON.parse(error);
		// result = error.message;
		result = error;
		// } catch {
		//   return '';
		// }
	} else if (Array.isArray(error)) {
		result = error.join('<br/>');
	}

	// let codeEntry = messages.messages[error.errorType];

	// if (typeof error.message === 'string') {
	// result = error.message;
	// } else if (Array.isArray(error.message)) {
	//   result = error.message.join('')
	// }

	// if (!language) { language = 'pt-br'; }

	// if (codeEntry && codeEntry[language]) {
	//   result = codeEntry[language];
	// }

	return result;
};

const getMessageByCode = (code) => {
	let codeEntry = messages.messages[code];
	const language = getLanguageByCode();
	return codeEntry[language];
};

export default {
	getTooltip,
	getMessage,
	getMessageByCode,
	getLanguageByCode,
};
